class EveningLookAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button[data-items]');
    this.error = this.querySelector('.evening-looks__error');
    if (!this.button) return;
    this.onClick = this.onClick.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.onClick);
  }

  async onClick() {
    let items;
    try {
      items = JSON.parse(this.button.dataset.items || '[]');
    } catch (err) {
      return;
    }
    items = items.filter((item) => item && item.id && item.quantity > 0);
    if (!items.length) return;

    this.setError('');
    this.button.classList.add('btn--loading');
    this.button.setAttribute('aria-disabled', 'true');

    const addUrl =
      (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add';
    const cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          // Без этого заголовка Shopify не проверяет остаток и молча принимает
          // количество больше, чем есть на складе.
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        this.setError(data.description || data.message || '');
        return;
      }
      window.location.href = cartUrl;
    } catch (err) {
      this.setError('');
    } finally {
      this.button.classList.remove('btn--loading');
      this.button.removeAttribute('aria-disabled');
    }
  }

  setError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = !message;
  }
}

if (!customElements.get('evening-look-add')) {
  customElements.define('evening-look-add', EveningLookAdd);
}
